import {HorseBetInfoModel} from '../../../model/horse/HorseBetInfoModel';
import { WPStrategiesChoice, QQPStrategiesChoice, WPStrategiesChoiceLangKey, QQPStrategiesChoiceLangKey } from '../../../util/Constants';
import {Injectable} from '@angular/core';
import { BetTable } from './BetTable';
import { HorseRaceModel } from '../../../model/horse/HorseRaceModel';
import { StrategyTable } from './StrategyTable';
import { TranslateService } from '@ngx-translate/core';



/*
  Generated class for the HorseBetDataProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HorseBetDataProvider {
  MAX_WP_HORSES_COUNT: number = 6;
  MAX_QQP_SEL_HORSES_COUNT_WITH_BANKER: number = 5;
  MAX_QQP_SEL_HORSES_COUNT_WITHOUT_BANKER: number = 6;

  NO_P_HIDE_ITEM_LIST = [2, 3, 4, 5, 6, 7, 8, 9];
  NO_Q_HIDE_ITEM_LIST = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  NO_QP_HIDE_ITEM_LIST = [2, 3, 4, 5, 6, 7, 8, 9];



  //betPriceTable: any = null;

  constructor(private translateService:TranslateService) {
  }

  getWPStrategy(hasP: boolean): Array<any>{
    let strategies: Array<any> = new Array<any>();
    for (let wpChoice in WPStrategiesChoice) {
      if (!isNaN(Number(wpChoice))) {
        let value = Number(wpChoice);
        let label = WPStrategiesChoiceLangKey[wpChoice];
        if (!hasP && this.NO_P_HIDE_ITEM_LIST.indexOf(value) > -1) {
          continue;
        }
        strategies.push({label: label, value: value});
      }
    }
    return strategies;
  }

  getQQPStrategy(hasQ: boolean, hasQP: boolean): Array<any> {
    let strategies: Array<any> = new Array<any>();
    for (let qqpChoice in QQPStrategiesChoice) {
      if (!isNaN(Number(qqpChoice))) {
        let value = Number(qqpChoice);
        let label = QQPStrategiesChoiceLangKey[qqpChoice];
        if (value == 6 || value == 9) {
          continue;
        }
        if (!hasQ && this.NO_Q_HIDE_ITEM_LIST.indexOf(value) > -1) {
          continue;
        }
        if (!hasQP && this.NO_QP_HIDE_ITEM_LIST.indexOf(value) > -1) {
          continue;
        }
        strategies.push({label: label, value: value});
      }
    }
    return strategies;
  }

  public getBetInfo(confidenceLevel, wpStrategyIdx, wpHorseCount, qqpStrategyIdx, qqpHasBanker, qqpSelCount): HorseBetInfoModel {
    let isMixed = wpStrategyIdx > 0 && qqpStrategyIdx > 0;

    let displayStrategyWP = "";
    let totalBetAmountWP = 0;
    let totalBetsWP = 0;
    let betAmountW = 0;
    let betAmountP = 0;
    let totalBetsW = 0;
    let totalBetsP = 0;

    let displayStrategyQQP = "";
    let totalBetAmountQQP = 0;
    let totalBetsQQP = 0;
    let betAmountQ = 0;
    let betAmountQP = 0;
    let totalBetsQ = 0;
    let totalBetsQP = 0;

    if (wpStrategyIdx > 0 && wpHorseCount > 0) {
      let wpBetTable;
      if (isMixed) {
        wpBetTable = BetTable.content.WPBet_QQPBet.WPBet[wpStrategyIdx];
      } else {
        wpBetTable = BetTable.content.WPBet[wpStrategyIdx];
      }
      displayStrategyWP = wpBetTable.display;
      let horseCountTableWP = wpBetTable.bet_value[wpHorseCount];
      totalBetAmountWP = parseInt(horseCountTableWP.value, 10) * confidenceLevel;
      totalBetsWP = parseInt(horseCountTableWP.total_bets, 10);

      betAmountW = horseCountTableWP.W == undefined ? 0 : parseInt(horseCountTableWP.W, 10) * confidenceLevel;
      betAmountP = horseCountTableWP.P == undefined ? 0 : parseInt(horseCountTableWP.P, 10) * confidenceLevel;

      totalBetsW = horseCountTableWP.W == undefined ? 0 : parseInt(horseCountTableWP.W_bets, 10);
      totalBetsP = horseCountTableWP.P == undefined ? 0 : parseInt(horseCountTableWP.P_bets, 10);
    }

    if (qqpStrategyIdx > 0 && qqpSelCount > 0) {
      let qqpBetTable;
      if (isMixed) {
        if (qqpHasBanker) {
          qqpBetTable = BetTable.content.WPBet_QQPBet.QQPBet.horse_selected_banker_sel[qqpStrategyIdx];
        } else {
          qqpBetTable = BetTable.content.WPBet_QQPBet.QQPBet.horse_selected_cross_sel[qqpStrategyIdx];
        }
      } else {
        if (qqpHasBanker) {
          qqpBetTable = BetTable.content.QQPBet.horse_selected_banker_sel[qqpStrategyIdx];
        } else {
          qqpBetTable = BetTable.content.QQPBet.horse_selected_cross_sel[qqpStrategyIdx];
        }
      }

      displayStrategyQQP = qqpBetTable.display;
      let horseCountTableQQP = qqpBetTable.bet_value[qqpSelCount];
      totalBetAmountQQP = parseInt(horseCountTableQQP.value, 10) * confidenceLevel;
      totalBetsQQP = parseInt(horseCountTableQQP.total_bets, 10);

      betAmountQ = horseCountTableQQP.Q == undefined ? 0 : parseInt(horseCountTableQQP.Q, 10) * confidenceLevel;
      betAmountQP = horseCountTableQQP.QP == undefined ? 0 : parseInt(horseCountTableQQP.QP, 10) * confidenceLevel;

      totalBetsQ = horseCountTableQQP.Q == undefined ? 0 : parseInt(horseCountTableQQP.Q_bets, 10);
      totalBetsQP = horseCountTableQQP.QP == undefined ? 0 : parseInt(horseCountTableQQP.QP_bets, 10);
    }

    let totalBetAmount = totalBetAmountWP + totalBetAmountQQP;

    let betInfoModel = new HorseBetInfoModel(totalBetAmount, displayStrategyWP, totalBetAmountWP, totalBetsWP, betAmountW, totalBetsW, betAmountP, totalBetsP,
      displayStrategyQQP, totalBetAmountQQP, totalBetsQQP, betAmountQ, totalBetsQ, betAmountQP, totalBetsQP);

    return betInfoModel;
  }

  public checkInRaceBet(race: HorseRaceModel, wpStrategy: number, qqpStrategy: number, isSubmit: boolean): Object {
    let result = true;
    let errors = [];
    let horses = race.horses;

    let wpHorseCount = 0;
    let qqpBankerCount = 0;
    let qqpSelCount = 0;
    let qqpHasBanker = false;
    let isMixed = wpStrategy > 0 && qqpStrategy > 0;
    for (let horse of horses) {
      if (horse.wpSelected) {
        wpHorseCount++;
      }
      if (horse.qqpBankerSelected) {
        qqpBankerCount++;
        qqpHasBanker = true;
      }
      if (horse.qqpSelSelected) {
        qqpSelCount++;
      }
    }



    if (wpHorseCount > this.MAX_WP_HORSES_COUNT) {
      result = false;
      errors.push({ key: "alertMessageWPMaxHorses", params: { wpHorseCount: this.MAX_WP_HORSES_COUNT}});
      return {result: result, errors: errors};
    }

    for (let horse of horses) {
      if (horse.scratched && (horse.wpSelected || horse.qqpBankerSelected || horse.qqpSelSelected)) {
        result = false;
        errors.push({ key: "alertMessageCannotChooseScratchedHorse", params: {}});
        return {result: result, errors: errors};
      }
    }

    if (qqpHasBanker && qqpSelCount > this.MAX_QQP_SEL_HORSES_COUNT_WITH_BANKER) {
      result = false;
      errors.push({ key: "alertMessageMaxSelHorsesWithBanker", params: { "bankerCount" : 1, "selCount" : this.MAX_QQP_SEL_HORSES_COUNT_WITH_BANKER }});
      return {result: result, errors: errors};
    }

    if (!qqpHasBanker && qqpSelCount > this.MAX_QQP_SEL_HORSES_COUNT_WITHOUT_BANKER) {
      result = false;
      errors.push({ key: "alertMessageMaxSelHorsesWithoutBanker", params: { "selCount" : this.MAX_QQP_SEL_HORSES_COUNT_WITHOUT_BANKER }});
      return {result: result, errors: errors};
    }

    // check only if submit mode
    if(isSubmit) {
      if (wpStrategy == 0 && wpHorseCount > 0) {
        result = false;
        errors.push({ key: "PleaseSelectStrategyType", params: {strategyType: this.translateService.instant("winAndPlace")}});
        return {result: result, errors: errors};
      }

      if (qqpStrategy == 0 && (qqpBankerCount + qqpSelCount) > 0) {
        result = false;
        errors.push({ key: "PleaseSelectStrategyType", params: {strategyType: this.translateService.instant("quinellaAndQuinellaPlace")}});
        return {result: result, errors: errors};
      }

      if (wpStrategy == 0 && qqpStrategy == 0) {
        result = false;
        errors.push({key: "alertMessagePleaseSelectHorsesFromWPQQP", params: {}});
        return {result: result, errors: errors};
      }

      if (wpStrategy > 0 || qqpStrategy > 0) {
        if ((wpHorseCount + qqpBankerCount + qqpSelCount) == 0) {
          result = false;
          errors.push({key: "alertMessagePleaseSelectHorsesFromWPQQP", params: {}});
          return {result: result, errors: errors};
        }
      }

      // check qqp strategy
      if (qqpStrategy > 0) {
        let qqpStrategyTable;
        if (isMixed) {
          if (qqpHasBanker) {
            qqpStrategyTable = StrategyTable.content.WPBet_QQPBet.QQPBet.horse_selected_banker_sel[qqpSelCount];
          } else {
            qqpStrategyTable = StrategyTable.content.WPBet_QQPBet.QQPBet.horse_selected_cross_sel[qqpSelCount];
          }
        } else {
          if (qqpHasBanker) {
            qqpStrategyTable = StrategyTable.content.QQPBet.horse_selected_banker_sel[qqpSelCount];
          } else {
            qqpStrategyTable = StrategyTable.content.QQPBet.horse_selected_cross_sel[qqpSelCount];
          }
        }


        var qqpStrategyFound = qqpStrategyTable != undefined && qqpStrategyTable.indexOf(qqpStrategy) > -1;

        // strategy is invalid
        if (!qqpStrategyFound) {
          result = false;
          if (qqpHasBanker) {
            let availableChoices = "";
            for (let idx in qqpStrategyTable) {
              if (Number(idx) > 0) {
                if (availableChoices != "") {
                  availableChoices += ", ";
                }
                availableChoices += QQPStrategiesChoice[qqpStrategyTable[idx]];
              }
            }
            errors.push({ key: "alertMessageGenericIncorrectQQPStrategyWithBanker",
              params: { "bankerCount" : 1, "selCount" : qqpSelCount, "strategyType" : QQPStrategiesChoice[qqpStrategy], "availableChoices": availableChoices }});

          } else {
            let availableChoices = "";
            for (var idx in qqpStrategyTable) {
              if (Number(idx) > 0) {
                if (availableChoices != "") {
                  availableChoices += ", ";
                }
                availableChoices += QQPStrategiesChoice[qqpStrategyTable[idx]];
              }
            }
            errors.push({ key: "alertMessageGenericIncorrectQQPStrategyWithoutBanker",
              params: { "selCount" : qqpSelCount, "strategyType" : QQPStrategiesChoice[qqpStrategy], "availableChoices": availableChoices }});

          }
        }
      }
    }
    return {result: result, errors: errors};
  }

  public isStrategyHasQ(qqpStrategy) {
    return (qqpStrategy == QQPStrategiesChoice["Q"] || qqpStrategy == QQPStrategiesChoice["QQP"] || qqpStrategy == QQPStrategiesChoice["1Q2QP"]
      || qqpStrategy == QQPStrategiesChoice["1Q3QP"] || qqpStrategy == QQPStrategiesChoice["1Q5QP"] || qqpStrategy == QQPStrategiesChoice["2Q1QP"]
      || qqpStrategy == QQPStrategiesChoice["3Q1QP"] || qqpStrategy == QQPStrategiesChoice["5Q1QP"]);
  }

  public isStrategyHasQP(qqpStrategy) {
    return (qqpStrategy == QQPStrategiesChoice["QP"] || qqpStrategy == QQPStrategiesChoice["QQP"] || qqpStrategy == QQPStrategiesChoice["1Q2QP"]
      || qqpStrategy == QQPStrategiesChoice["1Q3QP"] || qqpStrategy == QQPStrategiesChoice["1Q5QP"] || qqpStrategy == QQPStrategiesChoice["2Q1QP"]
      || qqpStrategy == QQPStrategiesChoice["3Q1QP"] || qqpStrategy == QQPStrategiesChoice["5Q1QP"]);
  }

  public isStrategyHasW(wpStrategy) {
    return (wpStrategy == WPStrategiesChoice["W"] || wpStrategy == WPStrategiesChoice["WP"] || wpStrategy == WPStrategiesChoice["1W2P"]
      || wpStrategy == WPStrategiesChoice["1W3P"] || wpStrategy == WPStrategiesChoice["1W5P"] || wpStrategy == WPStrategiesChoice["2W1P"]
      || wpStrategy == WPStrategiesChoice["3W1P"] || wpStrategy == WPStrategiesChoice["5W1P"]);
  }

  public isStrategyHasP(wpStrategy) {
    return (wpStrategy == WPStrategiesChoice["P"] || wpStrategy == WPStrategiesChoice["WP"] || wpStrategy == WPStrategiesChoice["1W2P"]
      || wpStrategy == WPStrategiesChoice["1W3P"] || wpStrategy == WPStrategiesChoice["1W5P"] || wpStrategy == WPStrategiesChoice["2W1P"]
      || wpStrategy == WPStrategiesChoice["3W1P"] || wpStrategy == WPStrategiesChoice["5W1P"]);
  }

}



// WEBPACK FOOTER //
// ./src/providers/horse/horse-bet-data/horse-bet-data.ts